import React from 'react'
import styled from 'styled-components'
import IconControl from './icon-control'
import linkify from '../utils/linkify'
import colours from '../lib/colours'

const ExpandoLink = linkify(styled.span``, 'dark')

const ContainerDiv = styled.div`
  margin-bottom: 10px;
`

const PaddedContent = styled.div``

const PreviewContent = styled.div`
  overflow: hidden;
  height: 120px;
  position: relative;
`

const PreviewOverlay = styled.div`
  height: 120px;
  width: 100%;
  position: absolute;
`

interface IProps {
  title: string
  showPreview?: boolean
  previewBackground?: string
}

interface IState {
  expanded: boolean
}

class ExpandoControl extends React.Component<IProps, IState> {
  static defaultProps: { showPreview: boolean; previewBackground: string }

  state: IState = {
    expanded: false
  }

  handleToggle = () => this.setState(prev => ({ expanded: !prev.expanded }))

  render() {
    const rotation = this.state.expanded ? -90 : 0
    const iconStyle = {
      transform: `rotate(${rotation}deg)`,
      transition: 'transform 0.3s',
      marginRight: 8
    }
    let title: string
    if (this.state.expanded) {
      title = this.props.showPreview ? 'Show less' : 'Hide content'
    } else {
      title = this.props.title
    }
    return (
      <ContainerDiv>
        {this.state.expanded && <PaddedContent>{this.props.children}</PaddedContent>}
        {!this.state.expanded && this.props.showPreview && (
          <PreviewContent>
            <PreviewOverlay
              style={{
                background: `linear-gradient(transparent, transparent, ${this.props.previewBackground})`
              }}
            />
            {this.props.children}
          </PreviewContent>
        )}
        <div>
          <ExpandoLink onClick={this.handleToggle}>
            <IconControl icon="chevron-right" style={iconStyle} />
            {title}
          </ExpandoLink>
        </div>
      </ContainerDiv>
    )
  }
}

ExpandoControl.defaultProps = {
  showPreview: false,
  previewBackground: `${colours.white}`
}

export default ExpandoControl
